import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AssetTokenFormData {
  tokenSymbol: string;
  assetType: string;
  assetName: string;
  assetValue: string;
  assetLocation: string;
  certificateNumber: string;
  description: string;
  minimumInvestment: string;
  managementFee: string;
  insuranceCoverage: string;
  blockchain: string;
  tokenStandard: string;
  networkType: string;
  deployToBlockchain: boolean;
}

interface SettingsState {
  sessionTimeoutMinutes: number;
  assetTokenFormData: AssetTokenFormData | null;
}

const initialState: SettingsState = {
  sessionTimeoutMinutes: 5, // Default to 5 minutes
  assetTokenFormData: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSessionTimeoutMinutes(state, action: PayloadAction<number>) {
      state.sessionTimeoutMinutes = action.payload;
    },
    setAssetTokenFormData(state, action: PayloadAction<AssetTokenFormData | null>) {
      state.assetTokenFormData = action.payload;
    },
    updateAssetTokenFormField(state, action: PayloadAction<{ field: keyof AssetTokenFormData; value: string | boolean }>) {
      if (state.assetTokenFormData) {
        (state.assetTokenFormData as any)[action.payload.field] = action.payload.value;
      }
    },
    clearAssetTokenFormData(state) {
      state.assetTokenFormData = null;
    },
  },
});

export const { 
  setSessionTimeoutMinutes, 
  setAssetTokenFormData, 
  updateAssetTokenFormField, 
  clearAssetTokenFormData 
} = settingsSlice.actions;

export default settingsSlice.reducer; 